<ion-header class="ion-no-border app-inner-padding">
	<ion-grid class="ion-no-padding">
		<ion-row class="ion-no-padding">
			<ion-col size="6">
				<ion-title size="small" class="ion-no-padding">Sort</ion-title>
			</ion-col>
			<ion-col size="6">
				<ion-buttons>
					<ion-button (click)="applyFilters()">Select</ion-button>
				</ion-buttons>
			</ion-col>
		</ion-row>
		<ion-row class="ion-padding"></ion-row>
		<ion-row class="ion-no-padding">
			<ion-col size="12">
				<ion-buttons>
					<ion-button
						*ngFor="let item of sortType | enumToArray"
						(click)="onSortDirectionSelected(item)"
						[ngClass]="item.toLowerCase().startsWith(selectedSortDirection) ? 'selected' : ''"
						>{{ item }}</ion-button
					>
				</ion-buttons>
			</ion-col>
		</ion-row>
	</ion-grid>
</ion-header>
<ion-content class="inner-content app-inner-padding">
	<ion-list lines="none" class="ion-no-padding">
		<ion-item
			*ngFor="let item of internalSortModel.columns"
			(click)="onItemSelected(item)"
			[ngClass]="item.isSelected ? 'selected' : ''"
			class="ion-no-padding"
		>
			<ion-grid class="ion-no-padding">
				<ion-row>
					<ion-col size="12">
						<ion-label>{{ item.displayName }}</ion-label>
						<ion-icon class="icon-Save"></ion-icon>
					</ion-col>
				</ion-row>
			</ion-grid>
		</ion-item>
	</ion-list>
</ion-content>
